// Frontend-spezifische Stimulus Controller
// Nur die Controller laden, die im Frontend (Karriereportal) benötigt werden

import { application } from "./application"

// Search & Filter
import SearchFilterController from "./search_filter_controller"
application.register("search-filter", SearchFilterController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

// UI Components
import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import ReadMoreController from "./read_more_controller"
application.register("read-more", ReadMoreController)

import SmoothScrollingController from "./smooth_scrolling_controller"
application.register("smooth-scrolling", SmoothScrollingController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import VideoController from "./video_controller"
application.register("video", VideoController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

// Dropdowns & Modals (tdropdown wird via disclosure gehandhabt)

// Forms
import ValidationController from "./validation_controller"
application.register("validation", ValidationController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import FileInputController from "./file_input_controller"
application.register("file-input", FileInputController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import FrontendNestedFormController from "./frontend_nested_form_controller"
application.register("frontend-nested-form", FrontendNestedFormController)

import UnsavedChangesController from "./unsaved_changes_controller"
application.register("unsaved-changes", UnsavedChangesController)

import SelectRevealController from "./select_reveal_controller"
application.register("select-reveal", SelectRevealController)

import SelectTitleController from "./select_title_controller"
application.register("select-title", SelectTitleController)

import FreelancerToggleController from "./freelancer_toggle_controller"
application.register("freelancer-toggle", FreelancerToggleController)

import RangeSliderController from "./range_slider_controller"
application.register("range-slider", RangeSliderController)

import NationalityController from "./nationality_controller"
application.register("nationality", NationalityController)

import PhoneNumberController from "./phone_number_controller"
application.register("phone-number", PhoneNumberController)

import CitySearchController from "./city_search_controller"
application.register("city-search", CitySearchController)

import ScrollToShowController from "./scroll_to_show_controller"
application.register("scroll-to-show", ScrollToShowController)

// Job Portal specific
import ApplyCtaController from "./apply_cta_controller"
application.register("apply-cta", ApplyCtaController)

// Notifications & Alerts
import ToastrController from "./toastr_controller"
application.register("toastr", ToastrController)

import AlertController from "./alert_controller"
application.register("alert", AlertController)

// Navigation
import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SidebarToggleController from "./sidebar_toggle_controller"
application.register("sidebar-toggle", SidebarToggleController)

